import { create } from "zustand";

/**
 * Ref-count of open sidebar fly-out overlays (dropdowns, support panel). Used
 * to suppress sidebar item tooltips while collapsed so they don't overlap an
 * open overlay to their right.
 */
interface SidebarOverlayStore {
  count: number;
  push: () => void;
  pop: () => void;
}

export const useSidebarOverlayStore = create<SidebarOverlayStore>((set) => ({
  count: 0,
  push: () => set((s) => ({ count: s.count + 1 })),
  pop: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));
